import React, { useEffect, useRef, useState, useCallback } from "react";
import UploadIcon from "./icons/upload.svg";
import FileIcon from "./icons/file.svg";
import CancelIcon from "./icons/cancel.svg";
import TextField from "@material-ui/core/TextField";
import Button from "./../../components/Button";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useHistory } from "react-router-dom";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { CancelModal } from "./cancelModal";
import {
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@material-ui/core";
import styles from "./HelpRequestForm.module.scss";
import ClassNames from "classnames";
import { useFormik } from "formik";
import * as yup from "yup";
import { getLocalValue, getToken } from "../../utils/auth";

let helpOption = [
  "Coaching framework (e.g. subjects, GROW, PDCA)",
  "System: User management",
  "System: Loading and accessibility",
  "System: Sessions and Checkpoints",
  "System: Dashboard",
  "Other",
];

export const RequestFrom = props => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [locationRadioValue, setLocationRadioValue] = useState("");
  const [functionalUnitDropdownList, setFunctionalUnitDropdownList] = useState(
    []
  );
  const [selectedFunctionalUnit, setSelectedFunctionalUnit] = useState("");
  const [impactedUserEmployeeId, setImpactedUserEmployeeId] = useState("");
  const [sessionIdOrURL, setSessionIdOrURL] = useState("");
  const [issue, setIssue] = useState("");

  const helpOptionDropdownList = helpOption;
  const [helpOptionDropdownValue, setHelpOptionDropdownValue] = useState("");
  const [files, setFiles] = useState([]);

  const [initialValues, setInitialValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [fileUploadError, setFileUploadError] = useState("");
  const [verified, setVerified] = useState(false);

  const fileInputRef = useRef(null);
  const history = useHistory();
  const { addNotification } = useNotification();

  const handleFormSubmit = async event => {
    const formData = new FormData();

    let token = "";

    if (sessionStorage.getItem("HRF_EMP_INFO")) {
      const empInfo = JSON.parse(sessionStorage.getItem("HRF_EMP_INFO"));
      token = empInfo.TOKEN;

      formData.append("employeeId", empInfo.EMPLOYEE_ID);
      formData.append("employeeName", empInfo.EMPLOYEE_NAME);
      formData.append("employeeEmailId", empInfo.EMPLOYEE_EMAIL_ID);
      formData.append("cc_email", empInfo.CC_EMAIL);
    } else if (props.employeeId && props.employeeId !== "") {
      token = getToken();

      formData.append("employeeId", props.employeeId);
      formData.append("employeeName", getLocalValue("u_fullname"));
      formData.append("employeeEmailId", getLocalValue("u_email"));
      formData.append("employeeRole", getLocalValue("u_role"));
    }

    formData.append("workLocation", locationRadioValue);
    formData.append("functionalUnit", selectedFunctionalUnit);
    formData.append("impactedUserEmployeeId", impactedUserEmployeeId);
    formData.append("sessionIdOrURL", sessionIdOrURL);
    formData.append("helpOption", helpOptionDropdownValue);
    formData.append("issue", issue);
    formData.append("country", props.country);

    files.forEach(file => {
      formData.append("attachment", file);
    });

    // console.log("attempting to post Data", formData.getAll("attachment"));
    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`);
    // }

    try {
      setIsLoading(true);

      const response = await apiRequest.post(
        `/api/submitHelpRequest`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        //sessionStorage.removeItem("HRF_EMP_INFO");
        history.push(`/help-request/${props.akey}/submitted`);
      } else {
        const errorData = response.data;
        if (!errorData.status) {
          if (errorData.key === "FILE_SIZE") {
            setFileUploadError(errorData.msg);
          } else {
            addNotification("Something went wrong!", "error");
          }
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileChange = event => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(prevFiles => [...prevFiles, ...selectedFiles]);
    event.target.value = null;
  };

  const handleRemoveFile = fileToRemove => {
    setFiles(prevFiles => prevFiles.filter(file => file !== fileToRemove));
  };

  //handle files dropped into the file upload container
  const handleDrop = e => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles(prevFiles => [...prevFiles, ...droppedFiles]);
  };

  //handle files dragged over to the file upload container
  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = e => {
    e.preventDefault();
  };

  useEffect(() => {
    setInitialValues({
      locationRadioValue: locationRadioValue ?? "",
      selectedFunctionalUnit: selectedFunctionalUnit ?? "",
      helpOption: helpOptionDropdownValue ?? "",
      issue: issue ?? "",
    });

    if (
      locationRadioValue !== "" &&
      selectedFunctionalUnit !== "" &&
      helpOptionDropdownValue !== "" &&
      issue !== ""
    ) {
      setVerified(true);
    } else {
      setVerified(false);
    }
  }, [
    selectedFunctionalUnit,
    locationRadioValue,
    helpOptionDropdownValue,
    issue,
  ]);

  useEffect(() => {
    let isMounted = true;
    //get the user campaigns
    const getUserCampaigns = async () => {
      try {
        setIsLoading(true);
        let userId = "";
        let token = "";
        if (sessionStorage.getItem("HRF_EMP_INFO")) {
          const empInfo = JSON.parse(sessionStorage.getItem("HRF_EMP_INFO"));
          userId = empInfo.UID;
          token = empInfo.TOKEN;
        } else if (props.employeeId && props.employeeId !== "") {
          userId = getLocalValue("uid");
          token = getToken();
        }
        const response = await apiRequest.get(
          `/api/getUserCampaignList?uid=${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.status === 200) {
          console.log("response.data.data", response.data.data);
          const campaigns = response.data.data;
          if (isMounted) {
            setFunctionalUnitDropdownList(campaigns);
            setSelectedFunctionalUnit(campaigns[0].functional_unit); // Only update state if mounted
          }
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getUserCampaigns();
    return () => {
      isMounted = false;
      console.log("Component unmounted!");
    };
  }, []);

  //form validation
  const validationSchema = yup.object({
    locationRadioValue: yup
      .string()
      .required("Work location field is required"),
    selectedFunctionalUnit: yup
      .string()
      .required("Functional unit field is required"),
    helpOption: yup.string().required("Help option field is required"),
    issue: yup.string().required("Issue field is required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: values => {
      handleFormSubmit();
    },
    enableReinitialize: true,
  });

  const handleImpactedEmployeeIdChange = useCallback(e => {
    setImpactedUserEmployeeId(e.target.value);
  }, []);

  return (
    <div>
      <div className={ClassNames(styles.contentSection, styles.pt0)}>
        <div className={styles.countryBlock}>Country: {props.country}</div>
        <div
          className={ClassNames(
            styles.formSection,
            styles.pt30,
            styles.formWidth424
          )}
        >
          {props.employeeId && props.employeeId !== "" ? (
            <div className={ClassNames(styles.flexCenter, styles.pb45)}>
              <h1 className={styles.titleText}>Need help? Tell us here.</h1>
              <p className={ClassNames(styles.introText, styles.pt10)}>
                Simply fill out this quick form with your question or
                <br /> concern and our team will get you back on track. Please
                <br />
                note that each form is limited to one issue only.
              </p>
            </div>
          ) : (
            <></>
          )}

          <div className={ClassNames(styles.flexCenter, styles.pb40)}>
            <h6 className={styles.formLabel}>
              {"Where do you currently work from?*"}
            </h6>
            <p className={ClassNames(styles.formSubLabel)}>
              {
                "If you're submitting for a team member, specify their work location when the error happened."
              }
            </p>
            <RadioGroup
              style={{ width: "100%" }}
              name="locationRadioValue"
              value={locationRadioValue}
              onChange={event => {
                setLocationRadioValue(event.target.value);
                formik.handleChange(event);
              }}
              error={
                formik.touched.locationRadioValue &&
                Boolean(formik.errors.locationRadioValue)
              }
            >
              <div className={styles.radioContainer}>
                <FormControlLabel
                  value="Office"
                  control={<Radio />}
                  label={"Office"}
                  style={{ marginBottom: 0 }}
                />
              </div>
              <div className={styles.radioContainer}>
                <FormControlLabel
                  value="Home"
                  control={<Radio />}
                  label={"Home"}
                  style={{ marginBottom: 0 }}
                />
              </div>
              <div className={styles.radioContainer}>
                <FormControlLabel
                  value="Hybrid"
                  control={<Radio />}
                  label={"Hybrid"}
                  style={{ marginBottom: 0 }}
                />
              </div>
            </RadioGroup>
            {formik.touched["locationRadioValue"] &&
              formik.errors["locationRadioValue"] && (
                <FormHelperText
                  style={{ width: "100%", color: "red", textAlign: "left" }}
                >
                  {formik.errors["locationRadioValue"]}
                </FormHelperText>
              )}
          </div>

          <div className={styles.pb40}>
            <h6 className={styles.formLabel}>{"Functional Unit*"}</h6>
            <Select
              className={styles.formSelect}
              value={selectedFunctionalUnit}
              onChange={e => {
                setSelectedFunctionalUnit(e.target.value);
                formik.setFieldValue("selectedFunctionalUnit", e.target.value);
              }}
              name="selectedFunctionalUnit"
              error={
                formik.touched.selectedFunctionalUnit &&
                Boolean(formik.errors.selectedFunctionalUnit)
              }
              disableUnderline
            >
              {functionalUnitDropdownList.map((item, index) => (
                <MenuItem key={index} value={item.functional_unit}>
                  {item.functional_unit}
                </MenuItem>
              ))}
            </Select>
            {formik.touched["selectedFunctionalUnit"] &&
              formik.errors["selectedFunctionalUnit"] && (
                <FormHelperText
                  style={{ width: "100%", color: "red", textAlign: "left" }}
                >
                  {formik.errors["selectedFunctionalUnit"]}
                </FormHelperText>
              )}
          </div>

          <div className={styles.pb40}>
            <h6 className={styles.formLabel}>
              {"Employee ID of impacted user"}
            </h6>
            <p className={styles.formSubLabel}>
              {
                "Submitting for a team member? Specify their employee ID, or skip to the next question if it's not applicable."
              }
            </p>
            <TextField
              style={{ width: "100%" }}
              size="small"
              variant="outlined"
              placeholder="Enter ID here"
              InputProps={{
                sx: {
                  "& .MuiOutlinedInput-input": {
                    padding: "4px 8px",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                },
              }}
              value={impactedUserEmployeeId}
              onChange={handleImpactedEmployeeIdChange}
            />
          </div>

          <div className={styles.pb40}>
            <h6 className={styles.formLabel}>{"Session ID/URL"}</h6>
            <TextField
              style={{ width: "100%" }}
              size="small"
              variant="outlined"
              placeholder="Enter ID or URL for impacted session here"
              InputProps={{
                sx: {
                  "& .MuiOutlinedInput-input": {
                    padding: "4px 8px",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                },
              }}
              value={sessionIdOrURL}
              onChange={e => setSessionIdOrURL(e.target.value)}
            />
          </div>

          <div className={styles.pb40}>
            <h6 className={styles.formLabel}>
              {"What can we help you with today?*"}
            </h6>
            <Select
              className={styles.formSelect}
              value={helpOptionDropdownValue}
              onChange={e => {
                setHelpOptionDropdownValue(e.target.value);
                formik.setFieldValue("helpOption", e.target.value);
              }}
              placeholder="Select an option"
              displayEmpty
              disableUnderline
              name="helpOption"
              error={
                formik.touched.helpOption && Boolean(formik.errors.helpOption)
              }
            >
              <MenuItem
                value=""
                disabled
                style={{
                  display: helpOptionDropdownValue ? "none" : "block",
                }}
              >
                Select an option
              </MenuItem>
              {helpOptionDropdownList.map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
            {formik.touched["helpOption"] && formik.errors["helpOption"] && (
              <FormHelperText
                style={{ width: "100%", color: "red", textAlign: "left" }}
              >
                {formik.errors["helpOption"]}
              </FormHelperText>
            )}
          </div>

          <div className={styles.pb40}>
            <h6 className={styles.formLabel}>{"Tell us about the issue*"}</h6>
            <p className={styles.formSubLabel}>
              {
                "Feel free to include any relevant details, error messages, or steps you've already taken to troubleshoot. Your thorough description will help us resolve your issue swiftly."
              }
            </p>
            <TextField
              style={{ width: "100%" }}
              multiline
              minRows={5}
              size="small"
              variant="outlined"
              placeholder="Write your description here"
              InputProps={{
                sx: {
                  "& .MuiOutlinedInput-input": {
                    padding: "4px 8px",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                },
              }}
              value={issue}
              onChange={e => {
                setIssue(e.target.value);
                formik.handleChange(e);
              }}
              name="issue"
              error={formik.touched.issue && Boolean(formik.errors.issue)}
              helperText={formik.touched.issue && formik.errors.issue}
            />
          </div>
          <div className={styles.pb40}>
            <h6 className={styles.formLabel}>{"Supporting files"}</h6>
            <div
              className={styles.imgContainer}
              onDrop={handleDrop}
              onDragOver={handleDrag}
              onDragLeave={handleDragLeave}
            >
              <img src={UploadIcon} alt={"uploadIcon"} />
              <div className={styles.dragText}>
                {"Drag and drop a file here"}
              </div>
              <div className={styles.dragText}>{"or"}</div>
              <Button
                className={styles.selectFileButton}
                onClick={() => {
                  fileInputRef.current.click();
                  //TODO - upload file (img, video)
                }}
              >
                {"Select a file"}
              </Button>
            </div>

            <input
              type="file"
              accept="image/*,video/*"
              multiple
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <div
              style={{
                paddingTop: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                width: "424px",
              }}
            >
              {files.map((file, index) => (
                <div key={index} className={styles.filesContainer}>
                  <div className={styles.fileRow}>
                    <img
                      src={FileIcon}
                      alt="fileIcon"
                      style={{ paddingRight: "5px" }}
                    />
                    <div style={{ fontSize: "16px", fontWeight: "400px" }}>
                      {file.name}
                    </div>
                  </div>
                  <img
                    src={CancelIcon}
                    alt="cancelIcon"
                    style={{ paddingRight: "5px", cursor: "pointer" }}
                    onClick={() => {
                      handleRemoveFile(file);
                    }}
                  />
                </div>
              ))}
            </div>

            <div>
              {fileUploadError && fileUploadError !== "" && (
                <FormHelperText
                  style={{ width: "100%", color: "red", textAlign: "left" }}
                >
                  {fileUploadError}
                </FormHelperText>
              )}
            </div>
          </div>
          <div className={styles.pb40}>
            <Button
              className={ClassNames(
                verified ? styles.formSubmitButton : styles.formCancelButton,
                styles.formGroup,
                styles.fullWidthBtn
              )}
              onClick={() => {
                //submitForm();
                formik.handleSubmit();
              }}
              disabled={!verified}
            >
              {"Submit request"}
            </Button>

            <div className={ClassNames(styles.cancelButton, styles.formGroup)}>
              <Button
                type="button"
                onClick={() => {
                  setIsCancelModalOpen(true);
                }}
              >
                {"Cancel"}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <CancelModal
        setIsCancelModalOpen={setIsCancelModalOpen}
        isCancelModalOpen={isCancelModalOpen}
      />
    </div>
  );
};
